// Icono de juego con forma de icono de app. Comparte layoutId entre pantallas
// para que el icono tocado en la portada viaje hasta la cabecera del juego.
import { motion } from 'framer-motion';
import { GAMES_BY_ID, type GameId } from '../games/catalog';

// Muelle críticamente amortiguado (sin rebote): el icono llega, no salta
export const ICON_SPRING = { type: 'spring', bounce: 0, duration: 0.45 } as const;

export default function GameIcon({ id, size = 64, shared = false, className = '' }: {
  id: GameId;
  size?: number;
  // shared: participa en la transición compartida entre portada y juego
  shared?: boolean;
  className?: string;
}) {
  const game = GAMES_BY_ID[id];
  return (
    <motion.div
      layoutId={shared ? `game-icon-${id}` : undefined}
      transition={ICON_SPRING}
      className={`relative shrink-0 shadow-icon ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.225,
        background: `rgb(var(--game-${id}))`,
      }}
      aria-hidden="true"
    >
      {/* Brillo superior sutil: la luz cae desde arriba sobre el material */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ borderRadius: 'inherit', background: 'linear-gradient(180deg, rgb(255 255 255 / 0.16), rgb(255 255 255 / 0) 55%)' }}
      />
      <svg
        viewBox="0 0 24 24"
        className="absolute text-white"
        style={{ inset: '19%', width: '62%', height: '62%' }}
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {game.glyph}
      </svg>
    </motion.div>
  );
}
